import axios from 'app/api/axios'
import { Shop } from './Models/ShopModel'

const getShops = async (): Promise<Shop[]> => {
	const response = await axios('/api/internal/shops/all')
	return response.data
}

export { getShops }
